import { formatInTimeZone } from 'date-fns-tz';
import { es } from 'date-fns/locale';

const TIME_ZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;
const DEFAULT_FORMAT = 'dd LLL yyyy';

function formatDate(value: any, format: string = DEFAULT_FORMAT, locale = es) {
  return formatInTimeZone(new Date(value), TIME_ZONE, format, {
    locale,
  });
}

export { formatDate };
